/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Accessible_FocusInputs */

const en_a11y_statement_accessible_focus = /** @type {(inputs: A11y_Statement_Accessible_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus management and visible focus indicators`)
};

const de_a11y_statement_accessible_focus = /** @type {(inputs: A11y_Statement_Accessible_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus-Management und sichtbare Fokusindikatoren`)
};

const fr_a11y_statement_accessible_focus = /** @type {(inputs: A11y_Statement_Accessible_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion du focus et indicateurs de focus visibles`)
};

const es_a11y_statement_accessible_focus = /** @type {(inputs: A11y_Statement_Accessible_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion del enfoque e indicadores de enfoque visibles`)
};

const it_a11y_statement_accessible_focus = /** @type {(inputs: A11y_Statement_Accessible_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione del focus e indicatori di focus visibili`)
};

const nl_a11y_statement_accessible_focus = /** @type {(inputs: A11y_Statement_Accessible_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focusbeheer en zichtbare focusindicatoren`)
};

const pl_a11y_statement_accessible_focus = /** @type {(inputs: A11y_Statement_Accessible_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarzadzanie fokusem i widoczne wskazniki fokusu`)
};

const fi_a11y_statement_accessible_focus = /** @type {(inputs: A11y_Statement_Accessible_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohdistuksen hallinta ja näkyvät kohdistusindikaattorit`)
};

const da_a11y_statement_accessible_focus = /** @type {(inputs: A11y_Statement_Accessible_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokusstyring og synlige fokusindikatorer`)
};

const sv_a11y_statement_accessible_focus = /** @type {(inputs: A11y_Statement_Accessible_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokushantering och synliga fokusindikatorer`)
};

/**
* | output |
* | --- |
* | "Focus management and visible focus indicators" |
*
* @param {A11y_Statement_Accessible_FocusInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_accessible_focus = /** @type {((inputs?: A11y_Statement_Accessible_FocusInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Accessible_FocusInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_accessible_focus(inputs)
	if (locale === "fr") return fr_a11y_statement_accessible_focus(inputs)
	if (locale === "es") return es_a11y_statement_accessible_focus(inputs)
	if (locale === "it") return it_a11y_statement_accessible_focus(inputs)
	if (locale === "nl") return nl_a11y_statement_accessible_focus(inputs)
	if (locale === "pl") return pl_a11y_statement_accessible_focus(inputs)
	if (locale === "fi") return fi_a11y_statement_accessible_focus(inputs)
	if (locale === "da") return da_a11y_statement_accessible_focus(inputs)
	if (locale === "sv") return sv_a11y_statement_accessible_focus(inputs)
	return en_a11y_statement_accessible_focus(inputs)
});